export const THEMEWIZARD_ADD_SERVICE = 'ThemeWizard/AddService';

export default {
  THEMEWIZARD_ADD_SERVICE,
}